var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 80,
    viewBox: "2 20 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3492 0.569824H12.5192C5.85314 0.569824 0.449219 5.97374 0.449219 12.6398V27.4698C0.449219 34.1359 5.85314 39.5398 12.5192 39.5398H27.3492C34.0153 39.5398 39.4192 34.1359 39.4192 27.4698V12.6398C39.4192 5.97374 34.0153 0.569824 27.3492 0.569824Z",
    fill: "url(#paint0_linear_86_146)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_146",
    x1: -0.250781,
    y1: 17.5398,
    x2: 40.1292,
    y2: 22.5598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40E8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#009EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#27348A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#662482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5007E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonColor);
export default __webpack_public_path__ + "static/media/button-color.fafbdbc868405e80645f69689f5413dd.svg";
export { ForwardRef as ReactComponent };